// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"78b3bc0c","136":"78b3bc0c"}[chunkId] + ".chunk.css";
};